/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from './api';

// Identity
export async function getIdentityStatus() { return (await api.get('/identity/status')).data; }
export async function submitManualVerify(payload) { return (await api.post('/identity/manual-verify', payload)).data; }
export async function startSpid(provider_id) { return (await api.post('/identity/spid/start', { provider_id })).data; }
export async function startCie() { return (await api.post('/identity/cie/start')).data; }

// FHIR
export async function exportFhirBundle() { return (await api.get('/fhir/export')).data; }
export async function importFhirBundle(bundle, dry_run = false) { return (await api.post('/fhir/import', { bundle, dry_run })).data; }
export async function getFhirReadiness() { return (await api.get('/fhir/readiness')).data; }
export async function exportSoapAsFhir(payload) {
  // payload: { appointment_id, patient_id, subjective, objective, assessment, plan, language, started_at, ended_at }
  return (await api.post('/fhir/soap-encounter', payload)).data;
}

// GDPR
export async function requestGdprExport() {
  const res = await api.get('/gdpr/export', { responseType: 'blob' });
  return res.data;
}
export async function deleteAccount(confirm_email, reason) {
  return (await api.post('/gdpr/delete-account', { confirm_email, reason })).data;
}
export async function cancelDeleteAccount() { return (await api.post('/gdpr/cancel-delete')).data; }

// Analytics
export async function getDoctorAnalytics() { return (await api.get('/analytics/doctor')).data; }

// Public profile
export async function getPublicDoctor(slug) { return (await api.get(`/public/doctor/${slug}`)).data; }
